import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/****************  GET INSURANCE REPORT START ********************** */
export const getInsuranceReportDetails = (fetchData: any) => {
	const data = {
		GetInsuranceReportDetailsToken: fetchData,
	};
	const url = `${API_URL}GetInsuranceReportsDetailsList`;
	return makeApiCall(url, data);
};

/****************  GET INSURANCE REPORT END ********************** */
